// extracted by mini-css-extract-plugin
export default {"landingContainer":"landing_landingContainer__w6yi+","entry":"landing_entry__Q3FFH"};